
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { ContentSuggestion } from './viral-content/types';
import { MOCK_SUGGESTIONS } from './viral-content/mockData';
import ContentSuggestionsList from './viral-content/ContentSuggestionsList';
import TrendInsights from './viral-content/TrendInsights';
import ContentCalendar from './viral-content/ContentCalendar';
import ContentPerformance from './viral-content/ContentPerformance';

const ViralContentGenerator: React.FC = () => {
  const { toast } = useToast();
  const [suggestions, setSuggestions] = useState<ContentSuggestion[]>(MOCK_SUGGESTIONS);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedGenres, setSelectedGenres] = useState<string[]>(['pop', 'electronic']);

  const handleRefresh = () => {
    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      // Shuffling and slightly modifying existing suggestions for demo purposes
      const refreshedSuggestions = [...suggestions]
        .sort(() => Math.random() - 0.5)
        .map(s => ({
          ...s,
          engagement: Math.min(100, s.engagement + Math.floor(Math.random() * 10)),
          isNew: Math.random() > 0.5
        }));
      
      setSuggestions(refreshedSuggestions);
      setIsLoading(false);
      
      toast({
        title: "Content suggestions refreshed!",
        description: "New trending ideas have been generated based on your genre and audience."
      });
    }, 1500);
  };
  
  const handleUseIdea = (suggestion: ContentSuggestion) => {
    toast({
      title: "Idea added to your content calendar!",
      description: `"${suggestion.title}" has been saved as a draft post.`
    });
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-2xl font-bold mb-1">Viral Content Generator</h2>
          <p className="text-muted-foreground">AI-powered trending content ideas based on your genre and audience</p>
        </div>
        <Button 
          onClick={handleRefresh} 
          disabled={isLoading}
          variant="outline"
        >
          {isLoading ? "Refreshing..." : "Refresh Ideas"}
        </Button>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <ContentSuggestionsList 
            suggestions={suggestions}
            onUseIdea={handleUseIdea}
          />
        </div>
        
        <div className="space-y-6">
          <TrendInsights />
          <ContentCalendar />
          <ContentPerformance />
        </div>
      </div>
    </div>
  );
};

export default ViralContentGenerator;
